import { type PaymentMethod, type PointsReward } from './scan-to-pay.machine.types';

// ─── Context ────────────────────────────────────────────────────────────────

export type ScanToPayContext = Readonly<{
  availableCredit: number;
  availablePoints: number;
  paymentMethods: readonly PaymentMethod[];
  pointsRewards: readonly PointsReward[];

  useCredit: boolean;
  paymentMethodId: string;
  identifyToken: string;
  paymentToken: string;
}>;

export const initialContext: ScanToPayContext = {
  paymentMethods: [],
  pointsRewards: [],
  availableCredit: 0,
  availablePoints: 0,

  useCredit: true,
  paymentMethodId: '',
  identifyToken: '',
  paymentToken: '',
};
